import { getFallbackValueIfNull } from 'owa-options-core';
import getStore from '../data/store/store';
import { getCalendarConfiguration } from 'owa-calendar-configuration';
/*
 * Gets the fallback value for event duration option in events and invitation settings
 */
export function getMeetingDuration() {
    return getFallbackValueIfNull(getStore().defaultMeetingDuration, getCalendarConfiguration().DefaultMeetingDuration);
}
//# sourceMappingURL=getMeetingDuration.js.map